export type Nullable<T> = {
  [P in keyof T]: T[P] | null;
};

export type OptionalSpread<T> = T extends undefined ? [] : [T];
export * from './typed-changes';
